import { requests } from '.'
import servicesConfig from '../config/services'

const ChatWidgetService = {
  getCode: (locationId: string, isGTM = false) =>
    requests(servicesConfig.ChatWidget).get(`/code/${locationId}?isGTM=${isGTM}`)
}

export default ChatWidgetService
